<div class="container">
  <div
    fxLayout="column"
    fxLayoutAlign="center center"
    fxFill
    class="main"
  >
    <div fxLayout="column" fxLayoutAlign="center center" class="form-side">
      <form
        class="reset-box"
        (ngSubmit)="onSubmit()"
        #form="ngForm"
      >
        <div class="brand">
          <img src="../../../../../assets/img/wazir/wazir-logo-full.png" alt="WAZIR ERP" class="brand-logo" />
        </div>
        <div class="box-title">Nova Senha</div>
        <div class="box-subtitle">
          Crie uma nova senha para sua conta. Ela deve ter pelo menos 6 caracteres.
        </div>

        <!-- Nova Senha -->
        <div class="field">
          <label for="newPassword">NOVA SENHA</label>
          <div class="password-wrapper" [class.mismatch]="confirmPassword && !passwordsMatch">
            <input
              id="newPassword"
              [type]="showNew ? 'text' : 'password'"
              [(ngModel)]="newPassword"
              name="newPassword"
              required
              minlength="6"
              placeholder="Digite sua nova senha"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="toggle-visibility"
              (click)="showNew = !showNew"
              [title]="showNew ? 'Ocultar senha' : 'Mostrar senha'"
            >
              <mat-icon>{{ showNew ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          <span *ngIf="newPassword && newPassword.length < 6" class="hint-error">
            Mínimo 6 caracteres
          </span>
        </div>

        <!-- Confirmar Senha -->
        <div class="field">
          <label for="confirmPassword">CONFIRMAR SENHA</label>
          <div class="password-wrapper" [class.mismatch]="confirmPassword && !passwordsMatch">
            <input
              id="confirmPassword"
              [type]="showConfirm ? 'text' : 'password'"
              [(ngModel)]="confirmPassword"
              name="confirmPassword"
              required
              minlength="6"
              placeholder="Confirme sua nova senha"
              autocomplete="new-password"
            />
            <button
              type="button"
              class="toggle-visibility"
              (click)="showConfirm = !showConfirm"
              [title]="showConfirm ? 'Ocultar senha' : 'Mostrar senha'"
            >
              <mat-icon>{{ showConfirm ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
          </div>
          <span *ngIf="confirmPassword && !passwordsMatch" class="hint-error">
            As senhas não conferem
          </span>
        </div>

        <button
          class="btn-primary"
          type="submit"
          [disabled]="loading || !isFormValid"
        >
          {{ loading ? 'REDEFININDO...' : 'REDEFINIR SENHA' }}
        </button>

        <div class="back-link">
          <a [routerLink]="['/login']">Voltar para o login</a>
        </div>
      </form>
    </div>
  </div>
</div>
